module.exports = __webpack_public_path__ + "static/media/192x192.4f890bba.png";